// Maps a country name (ES or EN) to its flag emoji. Returns "" if unknown.
const NAME_TO_CODE = {
  panama: "PA", "panamá": "PA",
  bolivia: "BO",
  colombia: "CO",
  "méxico": "MX", mexico: "MX",
  argentina: "AR",
  chile: "CL",
  "perú": "PE", peru: "PE",
  ecuador: "EC",
  venezuela: "VE",
  uruguay: "UY",
  paraguay: "PY",
  "españa": "ES", spain: "ES",
  "estados unidos": "US", "united states": "US", usa: "US",
  brasil: "BR", brazil: "BR",
  "costa rica": "CR",
  guatemala: "GT",
  honduras: "HN",
  nicaragua: "NI",
  "el salvador": "SV",
  "república dominicana": "DO", "dominican republic": "DO",
  cuba: "CU",
  canada: "CA", "canadá": "CA",
};

export function countryFlag(name) {
  if (!name) return "";
  const code = NAME_TO_CODE[name.trim().toLowerCase()];
  if (!code) return "";
  // Convert ISO-3166 alpha-2 to regional indicator symbols (flag emoji).
  return code
    .toUpperCase()
    .replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
}
